/* eslint-disable import/order */
import React, { useState } from 'react';
import { arrayOf, func, shape, string } from 'prop-types';

// Components
import CarrierAuthCard from './CarrierAuthCard';
import { NoAuthorizationsAvailable } from 'feature/loading-management/shared-components';

const CardsList = ({ cards, handleRemove, onEdit, viewBy }) => {
  // this holds the card height, it is calculated from the first card rendered
  // it allows us to make future changes without worrying about changing a hard-coded height value
  // keeping the state value in cards list rather than in the card makes it so we only need to set one state value
  // even though we send both cardHeight and setCardHeight to the Card component
  const [cardHeight, setCardHeight] = useState(292);

  return cards.length ? (
    cards.map((card, index) => (
      <CarrierAuthCard
        {...card}
        cardHeight={cardHeight}
        handleRemove={handleRemove}
        // Use whichever ID value exists, prevents proptype errors
        index={index}
        // the following line is a hack to get the funky UI stuff to stop until we get good data from BE
        // please delete next line and uncomment the line after once the BE stops sending duplicate cards
        key={`${card.carrierAuthorizationId || card.authorizationId}${card.position}`}
        // key={card.carrierAuthorizationId || card.authorizationId}
        onEdit={onEdit}
        setCardHeight={setCardHeight}
        viewBy={viewBy}
      />
    ))
  ) : (
    <NoAuthorizationsAvailable />
  );
};

CardsList.propTypes = {
  cards: arrayOf(shape({})),
  handleRemove: func.isRequired,
  onEdit: func.isRequired,
  viewBy: string.isRequired,
};

CardsList.defaultProps = {
  cards: [],
};

export default CardsList;
